import * as React from 'react';
import {useForm, Path, UseFormRegister, SubmitHandler} from 'react-hook-form';
import {ClubSearchActionType} from '@nls-2022/nls-bll';
import {ApiError} from '@nls-2022/nls-bll';
import {addClub} from '@nls-2022/nls-api';
//import Button from '@mui/material/Button';
//import Paper from '@mui/material/Paper';
//import TextField from '@mui/material/TextField';
//import Select from '@mui/material/Select';
//import InputLabel from '@mui/material/InputLabel';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import Checkbox from '@mui/material/Checkbox';
import {PyramidContext} from '@nls-2022/nls-bll';
import {Link} from 'react-router-dom';
import {NLSTextInput} from '../form/NLSTextInput';
import {NLSCheckBox} from '../form/NLSCheckBox';
import {NLSSelectList} from '../form/NLSSelectList';

type props = {
  errors: Array<ApiError>;
};

type OptionProps = {
  index: string;
  option: string;
};

const StatusTypes: OptionProps[] = [
  {index: '0', option: 'Unknown'},
  {index: '1', option: 'Active'},
  {index: '2', option: 'Folded'},
  {index: '3', option: 'Resigned'},
  {index: '4', option: 'Merged'},
  {index: '5', option: 'Promoted to Football League'},
  {index: '6', option: 'Renamed'},
];
//const StatusTypes: Array<string> = ['x', 'y'];

export interface IClubDetailsInputFormValues {
  ClubName: string;
  ClubAddress: string;
  MainWebsite: string;
  Nicknames: string;
  ClubActive: boolean;
  DisableAutoUpdates: boolean;
}

export type InputProps = {
  label: Path<IClubDetailsInputFormValues>;
  register: UseFormRegister<IClubDetailsInputFormValues>;
  required: boolean;
  rest: any;
};

function ClubDetailsAddError(props: props) {
  let errorDetails = '';
  if (props.errors.length > 0) {
    props.errors.forEach(error => {
      errorDetails =
        errorDetails + error.PropertyName + ' : ' + error.ErrorMessage + '\n';
    });
    return <p>{errorDetails}</p>;
  }
  return <></>;
}

const PyramidSelectList = () => {
  const pyramidContext = React.useContext(PyramidContext);
  return (
    <>
      {pyramidContext.state.pyramidDetails
        ?.sort((a, b) => (a.leagueName! >= b.leagueName! ? 1 : -1))
        .map(pyramid => (
          <option value={pyramid.pyramidId}>{pyramid.leagueName}</option>
        ))}
    </>
  );
};
const ClubDetailsAdd = (props: any) => {
  const pyramidContext = React.useContext(PyramidContext);
  const pyramidDetails = pyramidContext.state.pyramidDetails
    ?.sort((a, b) => (a.leagueName! >= b.leagueName! ? 1 : -1))
    .map(pyramid => ({index: pyramid.pyramidId, option: pyramid.leagueName}));
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: {errors},
  } = useForm<IClubDetailsInputFormValues>();
  //const pyramidContext = React.useContext(PyramidContext);
  const [formErrors, setFormErrors] = React.useState<Array<ApiError>>([]);
  const [clubAdded, setClubAdded] = React.useState<boolean>(false);
  const [clubGuid, setClubGuid] = React.useState<string>('');

  const clubName = watch('ClubName', '');
  const clubAddress = watch('ClubAddress', '');
  const mainWebsite = watch('MainWebsite', '');
  const nicknames = watch('Nicknames', '');
  const clubActive = watch('ClubActive', true);
  const disableAutoUpdates = watch('DisableAutoUpdates', true);

  React.useEffect(() => {
    const initForm = () => {
      setValue('ClubName', '');
      setValue('ClubAddress', '');
      setValue('MainWebsite', '');
      setValue('Nicknames', '');
      setValue('ClubActive', true);
      setValue('DisableAutoUpdates', true);
    };
    initForm();
  }, [setValue]);

  const onSubmit = (data: any) => {
    //alert(data);
    //console.dir(data);
    //setClubAdded(true);
    try {
      //let clubDetail = addClub(data);
      addClub(data).then(clubDetail => {
        if (clubDetail!.fluentErrors?.length > 0) {
          setFormErrors(clubDetail!.fluentErrors);
        } else {
          setFormErrors([]);
          props.clubDispatch({
            type: ClubSearchActionType.ClubAdd,
            clubDetail: clubDetail,
          });
          setClubAdded(true);
          setClubGuid(clubDetail!.ClubGuid);
        }
      });
    } catch {}
  };
  //console.log(watch('ClubName')); // watch input value by passing the name of it
  if (clubAdded) {
    let socialAddLink = '/club/socialbasic/add/' + clubGuid;
    return (
      <section>
        <p>Club Added with id {clubGuid}</p>
        <p>
          Add Social Details <Link to={socialAddLink}>click here</Link>
        </p>
      </section>
    );
  } else {
    return (
      /* "handleSubmit" will validate your inputs before invoking "onSubmit" */
      <section>
        <form
          className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* register your input into the hook by invoking the "register" function */}
          <ClubDetailsAddError errors={formErrors} />
          <NLSTextInput
            register={register}
            defaultValue={clubName}
            name="ClubName"
            label="Club Name"
            errors={errors}
            validation={{
              required: {value: true, message: 'required'},
              minLength: {value: 2, message: 'minimum'},
            }}
          />
          <br />
          <NLSTextInput
            register={register}
            defaultValue={clubAddress}
            name="ClubAddress"
            label="Club Address"
            errors={errors}
            validation={{required: {value: true, message: 'required'}}}
          />
          <br />
          <NLSTextInput
            register={register}
            defaultValue={mainWebsite}
            name="MainWebsite"
            label="Website"
            errors={errors}
            validation={{required: true}}
          />
          <br />
          <NLSTextInput
            register={register}
            defaultValue={nicknames}
            name="Nicknames"
            label="Nicknames"
            errors={errors}
            validation={{required: true}}
          />
          <NLSCheckBox
            register={register}
            defaultValue={true}
            name="ClubActive"
            label="ClubActive"
            checked={clubActive}
          />
          <NLSCheckBox
            register={register}
            defaultValue={true}
            name="DisableAutoUpdates"
            label="Disable Updates"
            checked={disableAutoUpdates}
          />
          <NLSSelectList
            register={register}
            defaultValue={''}
            name="StatusTypedId"
            label="Status"
            options={StatusTypes}
          />
          <NLSSelectList
            register={register}
            defaultValue={''}
            name="PyramidId"
            label="League"
            options={pyramidDetails}
          />

          <button
            className="flex-shrink-0 bg-green-500 hover:bg-green-700 border-green-500 hover:border-green-700 text-sm border-4 text-white py-1 px-2 rounded uppercase"
            type="submit"
          >
            Submit
          </button>
        </form>
      </section>
    );
  }
};
export default ClubDetailsAdd;

/*
          <br />
          <input id="MainWebsite" defaultValue="" />
          <br />
          <input id="Nicknames" defaultValue="" />
          <br />
          <input color="primary" defaultChecked={true} />

          <br />
          <input color="primary" {...register('DisableAutoUpdate')} />
          <br />
          <label id="StatusTypeIdLabel">Status</label>
          <select id="StatusTypeId" {...register('StatusTypeId')}>
            <option value="0">Unknown</option>
            <option value="1">Active</option>
            <option value="2">Folded</option>
            <option value="3">Resigned</option>
            <option value="4">Merged</option>
            <option value="5">Promoted to Football League</option>
            <option value="6">Renamed</option>
          </select>
          <br />
          <label id="PyramidIdLabel">Pyramid</label>
          <select id="PyramidId" {...register('PyramidId')}>
            {pyramidContext.state.pyramidDetails
              ?.sort((a, b) => (a.leagueName! >= b.leagueName! ? 1 : -1))
              .map(pyramid => (
                <option value={pyramid.pyramidId}>{pyramid.leagueName}</option>
              ))}
          </select>
          <br />
          */
/*
 <NLSCheckBox
            register={register}
            defaultValue={true}
            name="DisableAutoUpdates"
            label="Disable Updates"
            checked={disableAutoUpdates}
          />
          */
